<template>
  <div class="exampleBox" v-show="showStatus" style="display: none;">
    <Header :colorType='colorType' :pageType='pageType' class="header"></Header>
    <div class="content">
      <Examplebanner></Examplebanner>
      <Siteexample></Siteexample>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/header/Header'
import Examplebanner from '@/components/example/exampleBanner'
import Siteexample from '@/components/example/exampleSite'
import Footer from '@/components/footer/Footer'
export default {
  name: 'Example',
  data: function () {
    return {
      showStatus: false,
      colorType: '3',
      pageType: 'example'
    }
  },
  components: {
    Header,
    Examplebanner,
    Siteexample,
    Footer
  },
  mounted: function () {
    this.showStatus = true
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}
.exampleBox{
  background-color: RGBA(247, 247, 247, 1);
}
.header{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
}
.content{
  margin-top: 120px;
  min-width: 1300px;
}
</style>



// WEBPACK FOOTER //
// src/components/example/Example.vue